export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/research_with_design-615773ddc45ba03baec7454558e6d516.png";